import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProposalForm from "./ProposalForm";
import { 
  useGetProposalByIdQuery,
  useUpdateProposalMutation,
  useReorderItemImagesMutation
} from "../../redux/api/proposalsApi";
import { toast } from "react-toastify";

const EditProposalPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: proposal, isLoading: loading, error } = useGetProposalByIdQuery(id);
  const [updateProposal, { isLoading: isUpdating }] = useUpdateProposalMutation();
  const [reorderItemImages] = useReorderItemImagesMutation();

  const handleUpdateProposal = async (data) => {
    try {
      // Use RTK Query mutation for proper state management
      await updateProposal({ id, ...data }).unwrap();
      
      // Save image orders for items that have them
      if (data.items) {
        for (const item of data.items) {
          if (item.proposal_item_id && item.image_order && item.image_order.length > 0) {
            try {
              await reorderItemImages({ 
                proposalItemId: item.proposal_item_id, 
                imageOrder: item.image_order 
              }).unwrap();
            } catch (err) {
              console.error('Failed to save image order for item:', item.proposal_item_id, err);
            }
          }
        }
      }
      
      toast.success("Proposal updated successfully!");
      navigate("/proposals");
    } catch (err) {
      console.error('Error updating proposal:', err);
      toast.error(err?.data?.error || "Failed to update proposal");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="alert alert-danger">Error: {error?.data?.error || error?.message || 'Failed to load proposal'}</div>;
  }

  if (!proposal) {
    return <div>No proposal found.</div>;
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="mb-0">Edit Proposal</h1>
        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate(`/proposals/${id}`)}
          title="Go back to proposal details without saving changes"
        >
          <i className="fas fa-arrow-left me-1"></i>
          Cancel Edit
        </button>
      </div>
      <ProposalForm 
        onSubmit={handleUpdateProposal} 
        loading={loading || isUpdating}
        initialData={proposal}
        isEdit={true}
        onCancel={() => navigate(`/proposals/${id}`)}
      />
    </div>
  );
};

export default EditProposalPage;
